export default {
  "content": "<path d=\"M9 5a1 1 0 10-2 0zM8 8H7a1 1 0 00.293.707zm.793 2.207a1 1 0 001.414-1.414zM14 8a6 6 0 01-6 6v2a8 8 0 008-8zm-6 6a6 6 0 01-6-6H0a8 8 0 008 8zM2 8a6 6 0 016-6V0a8 8 0 00-8 8zm6-6a6 6 0 016 6h2a8 8 0 00-8-8zM7 5v3h2V5zm.293 3.707l1.5 1.5 1.414-1.414-1.5-1.5z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "fill": "none",
    "height": "16",
    "width": "16",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};